import React ,{useEffect,useState} from 'react';
import style from './chart.module.scss';
import clickDotIcon from '@/modules/pain-points/img/clickDotIcon.svg';
import EventBus from '@/modules/pain-points/hooks/eventBus';

const clickDot = ({ index }) => {
  const [isDetailLoading, setIsDetailLoading] = useState(false);
  useEffect(() => {
    EventBus.addEventListener('isDetailLoading', handleIsDetailLoading);
    return (() => {
      EventBus.removeEventListener('isDetailLoading', handleIsDetailLoading);
    });
  }, []);
  const handleIsDetailLoading = (e) => {
    setIsDetailLoading(e.detail);
  };  

  return <>
    <div>
        {/* {isDetailLoading && index !=2 && (
          <div className={style.detailLoadingOverlay}>
            <div className={style.spinner}></div>
            <div className={style.loadingText}>Loading...</div>
          </div>
        )} */}
      <div style={{display: 'flex',flexDirection: 'column',alignItems: 'center',gap: '1vw'}}>
        <img src={clickDotIcon} style={{width: '3vw'}}/>
        <div style={{fontSize: '1vw',color: '#00A32E',textAlign: 'center'}}>Click on the above dot to view</div>
        <div style={{fontSize: '1vw',color: '#00A32E',textAlign: 'center'}}>details.</div>
      </div>
    </div>
  </>

}



export default clickDot;